export default __webpack_public_path__ + "static/media/va.0d419ae5.svg";